<template>
<v-dialog
    v-model="dialog"
    max-width="1200"
>
    <v-card>
        <v-card-title>New drip message</v-card-title>

        <v-card-text>
            <v-text-field
                label="Label"
                v-model="label"
                autocomplete="off"
            />

            <v-select
                label="Send From"
                v-model="send_from"
                :items="send_from_choices"
            />

            <m-edit-text
                label="Time to wait after a member is added to a list before sending"
                v-model="list_drip_delay"
                duration
            />

            <m-edit-message-patterns
                v-model="message_patterns"
                context="list-drip"
            />

            <m-edit-blobs
                label="Image (optional)"
                empty_text="No image"
                v-model="blob_ids"
                :process_media="true"
                :externally_visible="true"
                :allow_multiple="false"
                :limit_to_size="460800"
                style="padding-bottom: 7px; margin-bottom: 15px; border-bottom: 1px solid rgb(148,148,148); margin-top: 15px"
                edit_icon="mdi-lead-pencil"
                dialog_title="Select Image"
                dialog_hint="<b>Image limitations:</b>  Images <b>must</b> be 450 Kb or smaller.<br/><br/><b>Image size:  </b>For best results, images should be square or close to square.  The ideal image size is 400 x 400 pixels."
            />

            <m-select-vcard
                label="Attach contact card (optional)"
                v-model="vcard_id"
                ref="select-contact-card"
                style="margin-top: 15px"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Create
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            list_drip_delay: 24*60*60*1000,
            label: 'Your label here',
            message_patterns: ['Hi {first-name}, your message here!'],
            blob_ids: [],
            vcard_id: null,
            organization_id: null,
            list_id: null,  
            send_from_choices: [], 
            send_from: null,
        }
    },

    methods: {

        showDialog(organization_id, list_id, send_from)
        {
            this.organization_id = organization_id;
            this.list_id = list_id;
            this.send_from = send_from;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/numbers/send-from-choices/:organization_id',
            
                'params' : {
                        'organization_id': organization_id,
                    },
            
                'on_success': (data) => {
                        this.send_from_choices = data.send_from_choices;
                        this.dialog = true;
                    },
            
                'on_error': 'Unable to get send from number choices',
            });
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/lists/quick-drip-message-create',
            
                'params' : {
                        'organization_id': this.organization_id,
                        'list_id': this.list_id,
                        'label': this.label,
                        'message_patterns': this.message_patterns,
                        'list_drip_delay': this.list_drip_delay,
                        'send_from': this.send_from,
                        'blob_ids': this.blob_ids,
                        'vcard_id': this.vcard_id
                    },
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('ok');
                    },
            
                'on_error': 'Unable to create drip message',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        is_valid() {
            return this.send_from != null;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>